import { inject, Injectable } from '@angular/core';
import { AppSettings } from '../app.settings';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { CustomResponse } from '../interfaces/custom-response.model';

@Injectable({
  providedIn: 'root'
})
export class ChangesService {

  http = inject(HttpClient);
  apiEndpoint: string = AppSettings.settings.apiServer.backend;

  constructor() { }
  
  getChanges() : Observable<any>
    {
      let url = `${this.apiEndpoint}/changes`;
  
      return this.http.get<CustomResponse>(url);
    }

}
